module.exports = __webpack_public_path__ + "img/ws.c851b943.png";